<template>
  <div v-if="props" class="sub-page-header" :class="getSubPageHeaderClass(props.opacity)" :style="{ paddingTop: `max(${props.paddingTop}rem, calc(env(safe-area-inset-top)) + 15px)` }">
    <!--      <div class="sub-page-header__inner" :class="narrow ? 'sub-page-header__inner&#45;&#45;narrow' : ''" :style="{maxWidth: `${1440 - screen.scrollWidth}px`, transform: `translateX(-${screen.scrollWidth}px)`}">-->
    <div class="sub-page-header__inner" :class="narrow ? 'sub-page-header__inner--narrow' : ''">
      <div class="sub-page-header__inner-sub">
        <div class="sub-page-header__inner-sub_left">
          <div :style="{ fontSize: props.headerFontSize + 'px' }" style="visibility: hidden;">
            WAT
          </div>
          <transition name="slide-top">
            <div class="sub-page-header__item d-flex align-center" v-show="!$slots.interactiveBlock || (!contentUnderHeader && $slots.interactiveBlock)">
              <div :style="{ fontSize: props.headerFontSize + 'px' }">
                <slot></slot>
              </div>
            </div>
          </transition>

          <transition name="slide-bottom-small">
            <div class="sub-page-header__item sub-page-header__item--interactive" v-show="contentUnderHeader && $slots.interactiveBlock">
              <slot name="interactiveBlock"></slot>
            </div>
          </transition>
        </div>
        <div class="sub-page-header__inner-sub_right">
          <transition name="slide-top">
            <div class="sub-page-header__item sub-page-header__item--right" v-show="!$slots.interactiveControls || (!contentUnderHeader && $slots.interactiveControls)">
                <span :style="{ fontSize: props.headerFontSize + 'px' }">
                  <slot name="controls"></slot>
                </span>
            </div>
          </transition>

          <transition name="slide-bottom-small">
            <div class="sub-page-header__item sub-page-header__item--right sub-page-header__item--interactive" v-show="contentUnderHeader && $slots.interactiveControls">
              <slot name="interactiveControls"></slot>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import screen from '@/mixins/screen'
import safeArea from '@/mixins/safeArea'

export default {
  mixins: [screen, safeArea],

  props: {
    props: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      minPaddingTop: 1.5,
      maxPaddingTop: 6,
      paddingTop: 6,

      minFontSize: 18,
      maxFontSize: 30,
      fontSize: 30,

      opacity: 1,

      prevScrollTop: 0,
      contentUnderHeader: false,

      narrow: false
    }
  },

  methods: {
    // getPaddingTop (scrollTop) {
    //   if (this.screen.breakPoint.tabPort) {
    //     return this.minPaddingTop
    //   }
    //
    //   const paddingTop = this.maxPaddingTop - ((this.maxPaddingTop - this.minPaddingTop) / 100 * scrollTop)
    //   if (paddingTop < this.minPaddingTop) {
    //     this.paddingTop = this.minPaddingTop
    //   } else {
    //     this.paddingTop = paddingTop
    //   }
    //
    //   return this.paddingTop
    // },

    getSubPageHeaderClass (opacity) {
      this.opacity = opacity
      this.contentUnderHeader = opacity === 0
      return opacity === 0 ? 'sub-page-header--elevated' : ''
    },

    getFontSize (scrollTop) {
      if (this.screen.breakPoint.tabPort) {
        return this.maxFontSize
      }

      const fontSize = this.maxFontSize - ((this.maxFontSize - this.minFontSize) / 300 * scrollTop)
      if (fontSize <= this.minFontSize) {
        this.fontSize = this.minFontSize
      } else {
        this.fontSize = fontSize
      }

      return this.fontSize
    }
  },

  mounted () {
    // this.narrow = this.$route.name !== 'dashboard'
  },

  watch: {
    '$route.name' (val) {
      // this.narrow = val !== 'dashboard'
    }
  }
}
</script>

<style lang="scss">
.sub-page-header {
  position: relative;
  padding-bottom: 1.5rem;
  transition: all .1s;
  z-index: 2;

  &__inner {
    max-width: 120rem;
    margin-left: auto;
    margin-right: auto;

    &--narrow {
      max-width: 78rem;
    }

    padding-left: $default-spacing-mobile;
    padding-right: $default-spacing-mobile;

    @include respond(tab-port) {
      padding-left: $default-spacing;
      padding-right: $default-spacing;
    }

    &-sub {
      display: flex;
      justify-content: space-between;

      &_left {
        position: relative;
        flex-shrink: 0;
        flex-basis: 70%;
      }

      &_right {
        position: relative;
        flex-shrink: 0;
        flex-basis: 30%;
      }
    }
  }

  &__item {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    transition: all;

    font-weight: 700;

    &--right {
      left: unset;
      right: 0;
    }
  }

  @include respond(tab-port) {
    box-shadow: $elevation;
    //border-bottom: 1px $color-space-lighten solid;
  }

  &--elevated {
    box-shadow: $elevation;
  }
}
</style>
